import React from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";

function TermsNCondition() {
  return (
    <>
      <Navbar />
      <div className="news-banner news-banner-tnc">
        <p>Terms and Conditions</p>
        <br />
        <h1>Terms & Conditions –Cine Celebrate</h1>
        <p>Last Updated: 23rd July 2025</p>
      </div>
      <div className="tnc-revamp">
        <div className="tnc-revamp__intro">
          <p className="tnc-revamp__eyebrow">Booking Policy</p>
          <h2>Please review these terms before confirming your celebration.</h2>
          <p>
          Welcome to Cine Celebrate, your ultimate destination for personalized
          and private theater celebrations. By accessing our services—whether
          through our website, social media, WhatsApp, or in person—you agree to
          be bound by the following Terms & Conditions. These terms apply to all
          bookings, payments, cancellations, reschedules, and general conduct
          while using our private cinema experience.
          </p>
        </div>
        <ol className="tnc-revamp__list">
          <li>
            <strong>Booking & Confirmation</strong>
            <ul>
              <li>
                • All private theater bookings must be made in advance through
                our official channels: website, WhatsApp, phone call, or
                in-person at the venue.
              </li>
              <li>
                • Bookings are confirmed only upon successful full payment and
                are subject to availability.
              </li>
              <li>
                • We reserve the right to decline any booking request at our
                discretion.
              </li>
              <li>
                • A confirmation message, along with booking details, will be
                sent via email or WhatsApp once the payment is processed.
              </li>
            </ul>
          </li>
          <li>
            <strong>Payment Policy</strong>
            <ul>
              <li>• 100% payment is required to confirm your time slot.</li>
              <li>
                • We accept a wide range of secure payment options, including
                UPI, net banking, credit/debit cards, digital wallets, and QR
                code-based transfers.
              </li>
              <li>• Payment receipts are shared via WhatsApp and/or email.</li>
              <li>
                • All prices mentioned are inclusive of applicable taxes and
                convenience fees unless otherwise specified.
              </li>
            </ul>
          </li>
          <li>
            <strong>Cancellations, Refunds & Rescheduling</strong>
            <ul>
              <li>
                • 100% refund (excluding any gateway convenience charges) will
                be provided for cancellations made at least 72 hours prior to
                the scheduled event
              </li>
              <li>
                • No refunds will be issued for cancellations made within 72
                hours of your reserved slot.
              </li>
              <li>
                • Rescheduling is allowed one time only, with a request made
                minimum 72 hours before the event. It is subject to availability
                and cannot be guaranteed.
              </li>
              <li>
                • Refunds, where applicable, are usually processed within 24
                hours, and may take 3–5 business days to reflect in your
                account.
              </li>
            </ul>
          </li>
          <li>
            <strong>Event Timing & Guest Punctuality</strong>
            <ul>
              <li>
                • Events will strictly follow the pre-booked slot timings.
              </li>
              <li>
                • We recommend guests arrive 10–15 minutes early to ensure a
                full experience.
              </li>
              <li>
                • Late arrivals will not qualify for slot extensions or refunds.
              </li>
              <li>
                • If extra time is required, it may be offered on-spot based on
                availability and additional charges.
              </li>
            </ul>
          </li>
          <li>
            <strong>Theater Usage & Conduct</strong>
            <ul>
              <li>
                • Guests are expected to treat all equipment, decor, screens,
                seating, and facilities with care.
              </li>
              <li>
                • Any damages caused by misuse or negligence will be charged to
                the guest.
              </li>
              <li>
                • Smoking, alcohol consumption, and unauthorized
                photography/videography are strictly prohibited unless
                pre-approved.
              </li>
              <li>
                • Select locations offer wheelchair accessibility—please notify
                us during booking for assistance.
              </li>
            </ul>
          </li>
          <li>
            <strong>Content Guidelines</strong>
            <ul>
              <li>
                • Guests can stream their personalized content, including OTT
                shows, movies, music videos, or photo slideshows.
              </li>
              <li>
                • All media must comply with Indian copyright laws, and must not
                include any offensive, explicit, pirated, or illegal content.
              </li>
              <li>
                • Cine Celebrate reserves the right to decline or remove content
                it deems inappropriate, offensive, or in violation of law or
                brand policy.
              </li>
            </ul>
          </li>
          <li>
            <strong>Code of Conduct & Behaviour</strong>
            <ul>
              <li>
                • Guests must follow staff instructions and maintain decorum
                throughout the celebration.
              </li>
              <li>
                • We reserve the right to cancel or terminate an ongoing event
                without refund in case of:
                <ul>
                  <li>
                    &nbsp;&nbsp;&nbsp;&nbsp; Violent, rude, or disruptive
                    behaviour
                  </li>
                  <li>
                    &nbsp;&nbsp;&nbsp;&nbsp; Misuse of equipment or property
                  </li>
                  <li>
                    &nbsp;&nbsp;&nbsp;&nbsp; Violation of any safety or content
                    policy
                  </li>
                </ul>
              </li>
            </ul>
          </li>
          <li>
            <strong>Liability & Disclaimer</strong>
            <ul>
              <li>
                • Cine Celebrate is not responsible for loss or theft of
                personal belongings, unattended items, or user-generated
                content.
              </li>
              <li>
                • We shall not be liable for delays, reschedules, or
                cancellations due to:
                <ul>
                  <li>
                    &nbsp;&nbsp;&nbsp;&nbsp; Natural disasters (force majeure)
                  </li>
                  <li>
                    &nbsp;&nbsp;&nbsp;&nbsp; Government orders or local
                    restrictions
                  </li>
                  <li>
                    &nbsp;&nbsp;&nbsp;&nbsp; Technical glitches beyond our
                    control
                  </li>
                </ul>
              </li>
              <li>
                • All services are provided on an "as-is" basis without
                warranties of any kind.
              </li>
            </ul>
          </li>
          <li>
            <strong>Privacy & Data Usage</strong>
            <ul>
              <li>
                • Any personal or contact information collected during the
                booking process is used strictly for event management and
                communication.
              </li>
              <li>
                • We do not sell, rent, or share your data with third parties
                for marketing or any unauthorized use.
              </li>
              <li>
                • By booking, you consent to receive transactional and follow-up
                communication via SMS, email, or WhatsApp.
              </li>
            </ul>
          </li>
          <li>
            <strong>Intellectual Property</strong>
            <ul>
              <li>
                • All website content, promotional material, designs, and
                branding are owned by Cine Celebrate and protected under Indian
                copyright laws.
              </li>
              <li>
                • No portion of the website or branding may be reproduced,
                republished, or distributed without written permission.
              </li>
            </ul>
          </li>
          <li>
            <strong>Modifications to Terms</strong>
            <ul>
              <li>
                • Cine Celebrate reserves the right to update, revise, or amend
                these Terms & Conditions at any time, without prior notice.
              </li>
              <li>
                • The latest version will always be available on our official
                website. Please review it before booking.
              </li>
            </ul>
          </li>
          <li>
            <strong>Governing Law</strong>
            <p>
              These terms shall be governed by and interpreted in accordance
              with the laws of India. All disputes arising shall be subject to
              the exclusive jurisdiction of courts located in Delhi/NCR, unless
              otherwise specified
            </p>
          </li>
        </ol>
        <div className="tnc-revamp__footer">
          By proceeding with a booking or using our services, you agree to abide
          by these Terms & Conditions. We look forward to making your
          celebration truly cinematic.
        </div>
      </div>
      <Footer />
    </>
  );
}

export default TermsNCondition;
